export default () => (val) => moment(val).toDate();
